import {
    EMPLOYEES_SEND_NOTIFICATION_CLEAR,
    GET_USERS_ACTION_REQUEST,
    GET_USERS_ACTION_SUCCESS,
    GET_USERS_ACTION_FAILURE,
    ADD_ROLE_ACTION_REQUEST,
    ADD_ROLE_ACTION_SUCCESS,
    ADD_ROLE_ACTION_FAILURE,
    DELETE_ROLE_ACTION_REQUEST,
    DELETE_ROLE_ACTION_SUCCESS,
    DELETE_ROLE_ACTION_FAILURE
} from './constants';
import {Action} from '../types';

const initialState = {
    requestGetUsers: false,
    requestAddUsers: false,
    requestDeleteUsers: false,
    addUsersError: false,
    deleteUsersError: false,
    users: [],
    get: '',
    add: '',
    delete: ''
};

const emloyeesReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case EMPLOYEES_SEND_NOTIFICATION_CLEAR:
            return {
                ...state,
                addUsersError: false,
                deleteUsersError: false
            };
        case GET_USERS_ACTION_REQUEST:
            return {
                ...state,
                requestGetUsers: true
            };
        case GET_USERS_ACTION_SUCCESS:
            return {
                ...state,
                requestGetUsers: false,
                users: action.users
            };
        case GET_USERS_ACTION_FAILURE:
            return {
                ...state,
                requestGetUsers: false,
                get: action.message
            };
        case ADD_ROLE_ACTION_REQUEST:
            return {
                ...state,
                requestAddUsers: true
            };
        case ADD_ROLE_ACTION_SUCCESS:
            return {
                ...state,
                requestAddUsers: false,
                add: action.success
            };
        case ADD_ROLE_ACTION_FAILURE:
            return {
                ...state,
                requestAddUsers: false,
                addUsersError: true,
                add: action.error
            };
        case DELETE_ROLE_ACTION_REQUEST:
            return {
                ...state,
                requestDeleteUsers: true
            };
        case DELETE_ROLE_ACTION_SUCCESS:
            return {
                ...state,
                requestDeleteUsers: false,
                delete: action.success
            };
        case DELETE_ROLE_ACTION_FAILURE:
            return {
                ...state,
                requestDeleteUsers: false,
                deleteUsersError: true,
                delete: action.error
            };
        default:
            return state;
    }
};

export default emloyeesReducer;
